import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  VENDOR_ROLES_GET,
} from "../../types";
import { setErrors } from "../errorActions";

/********************************
 * @DESC Role management vendor
 *******************************/

export const vendor_create_role = (token, formData, onSuccess) => async (
  dispatch
) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    let vendor_create_role_response = await axios.post(
      `${serverApi}/role-management`,
      formData,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (vendor_create_role_response.status === 201) {
      onSuccess();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const vendor_role_management_get_all = (token, restaurant_id) => async (
  dispatch
) => {
  try {
    dispatch({ type: SET_LOADER });
    dispatch({ type: CLEAR_ERRORS });
    let response = await axios.get(
      `${serverApi}/role-management?restaurant_id=${restaurant_id}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status === 200) {
      dispatch({ type: VENDOR_ROLES_GET, payload: response.data });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const vendor_edit_role = (token, formData, onSuccess) => async (
  dispatch
) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    let response = await axios.patch(
      `${serverApi}/role-management/${formData._id}`,
      formData,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status === 200) {
      onSuccess();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const vendor_delete_role = (token, id, onSuccess) => async (
  dispatch
) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    let response = await axios.delete(`${serverApi}/role-management/${id}`, {
      headers: {
        Authorization: token,
      },
    });
    if (response.status === 200) {
      onSuccess();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
